import { cn } from '@/lib/utils';

/**
 * shadcn's skeleton, stock.
 *
 * Added because it was the one primitive this app had been hand-rolling: `states.tsx`
 * and `GifPicker` each write their own `animate-pulse` box, and `BirdPortrait` needed
 * a third. CLAUDE.md's rule is to reuse the primitive rather than re-invent it, so
 * this is the unmodified upstream component and the callers move to it as they are
 * touched — `bg-accent` and `bg-muted` are the same value in both themes here, so
 * nothing changes visually on the way.
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'animate-pulse rounded-md bg-accent motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
